import { AppContextState } from "src/AppContextProvider";

/**
 * Gates the /organization route.
 * Mirrors AdminNav's "organization" tab visibility:
 * org owners, or anyone with org brand / features / update abilities.
 * Viewers (read-only with no org admin abilities) are rejected,
 * closing pentest finding GRWBKK-1393 / PENTEST-138 / 3.3.1.
 */
export const canAccessOrganizationRoute = (
  context: AppContextState,
): boolean => {
  const p = context.currentPermissions;
  return (
    !!context.currentUser?.isOwner ||
    p.validateOrg("org", "brand") ||
    p.validateOrg("org", "features") ||
    p.validateOrg("org", "update")
  );
};
